import { EntityType } from '@vendasta/automata';

const singleName = {
  [EntityType.ENTITY_TYPE_NOT_SPECIFIED]: 'COMMON.ACCOUNT',
  [EntityType.ENTITY_TYPE_ACCOUNT_GROUP]: 'COMMON.ACCOUNT',
  [EntityType.ENTITY_TYPE_ORDER]: 'COMMON.ORDER',
  [EntityType.ENTITY_TYPE_USER]: 'COMMON.USER',
  [EntityType.ENTITY_TYPE_NO_ENTITY]: 'AUTOMATIONS.COMMON.ENTITY',
  [EntityType.ENTITY_TYPE_CONTACT]: 'AUTOMATIONS.COMMON.CONTACT',
  [EntityType.ENTITY_TYPE_COMPANY]: 'AUTOMATIONS.COMMON.COMPANY',
  [EntityType.ENTITY_TYPE_CUSTOM_OBJECT]: 'AUTOMATIONS.COMMON.CUSTOM_OBJECT',
};
export function getSingularEntityTypeDisplayTranslationString(entityType: EntityType): string {
  return singleName[entityType];
}
